import { axiosAiq } from 'config';
import { startOfDay, endOfDay } from 'date-fns';

export const getListAppointment = async ({ transactionId, locationId, gateDirection }) => {
    if (locationId) {
        const started = startOfDay(new Date());
        const ended = endOfDay(new Date());

        const params = {
            transactionId,
            started,
            ended,
            status: 'ACTIVE',
            gateDirection,
        };
        const { data } = await axiosAiq.get(`/appointments/location/${locationId}`, {
            params,
        });

        return data;
    }
};

export const getFormFields = async ({ gateId, locationId, companyId }) => {
    if (gateId && locationId && companyId) {
        const { data } = await axiosAiq.get(`/appointments/form-fields/transaction`, {
            params: { gateId, locationId, companyId },
        });
        return data;
    }
};
